import { Typography } from 'antd'
import CIMSTable from '../../../../../../../../../../components/CIMSTable'
import { CIMSTag } from '../../../../../../../../../../components/CIMSTag'
import { CSVImportResultJSON } from '@cims-online/shared'

interface ResultsTableProps {
  loading: boolean
  rows: CSVImportResultJSON['rows']
}

function ResultsTable({ rows, ...rest }: ResultsTableProps) {
  return (
    <CIMSTable
      rowKey="id"
      records={rows}
      size="small"
      expand={{
        render: (record) => {
          return {
            custom: [
              {
                label: 'Raw data',
                children: <pre>{JSON.stringify(record, null, 2)}</pre>,
              },
            ],
          }
        },
      }}
      columns={[
        {
          width: 50,
          title: 'Row',
          render: ({ id }) => id.toLocaleString(),
          filter: {
            type: 'number',
            key: 'id',
            with: 'key',
          },
        },
        {
          width: 75,
          title: 'Operation',
          render: ({ operation }) => <CIMSTag>{operation}</CIMSTag>,
          filter: {
            type: 'default',
            key: 'operation',
            with: 'key',
          },
        },
        {
          width: 400,
          title: 'Result',
          filter: {
            type: 'boolean',
            with: 'value',
            labels: { true: 'Successful', false: 'Unsuccessful' },
            value: ({ success }) => success,
          },
          render: ({ record, error }) =>
            record ? (
              `${record.payItemId} -  ${record.description}`
            ) : (
              <Typography.Text type="danger">
                {error?.description ?? 'Unknown error'}
              </Typography.Text>
            ),
        },
      ]}
      {...rest}
    />
  )
}

export default ResultsTable
